/**
 * LocalStorage
 */
import app from 'app';

app.namespace.Model.LocalStorage = function (options) {
  options = $.extend({ autosave: false }, options);

  this.Storage = window.localStorage;
  if (!_.isObject(this.Storage) || !_.isFunction(this.Storage.getItem)) {
    app.doctorController.report(
      'app.namespace.Model.LocalStorage: Storage interface is absent!'
    );
    this.Storage = {
      getItem: $.noop,
      setItem: $.noop,
    };
  }

  if (!_.isString(options.lsid)) {
    app.doctorController.report(
      'app.namespace.Model.LocalStorage: Missing `lsid` property during initialization!'
    );
  }

  this.lsid = options.lsid; // named identifier of model in localStorage
  this.defaults = options.defaults;

  Backbone.Model.apply(this, [{}]);

  if (options.autosave) {
    this.listenTo(this, 'change', this.save.bind(this));
  }
};

// Methods:
_.extend(app.namespace.Model.LocalStorage.prototype, Backbone.Model.prototype, {
  /**
   * fetch from localStorage by name
   */
  fetch: function () {
    const objStr = this.Storage.getItem(this.lsid);

    if (!_.isEmpty(objStr)) {
      const obj = JSON.parse(objStr);
      _.each(
        obj,
        $.proxy((value, key) => {
          this.set(key, value);
        })
      );
    }
  },

  /**
   * save model to named localStorage object
   */
  save: function () {
    const obj = this.attributes;

    if (!_.isEmpty(obj)) {
      const objStr = JSON.stringify(obj);
      try {
        this.Storage.setItem(this.lsid, objStr);
      } catch (bug) {
        _.try(function () {
          app.doctorController.report(
            'localStorage is full for user ' + app.rootStore.getters['user/id'],
            bug
          );
        });
      }
    }
  },
});

app.namespace.Model.LocalStorage.extend = Backbone.Model.extend;
export default app.namespace.Model.LocalStorage;
